function parseGroupMetadata(group) {
  try {
    return JSON.parse(group.description);
  } catch (e) {
    if (e.name === 'SyntaxError') {
      return {};
    }
    throw e;
  }
}

export default parseGroupMetadata;
